import { BaseSynth } from "./BaseSynth";
import { getAudioGraphInstance } from '../audioEngine';
import { SynthUI } from "../projectViews/stationViews/SynthUI";
import { addKeysAsField } from "../utils/misc";
import { Frequency, Distortion, dbToGain } from "tone";
import colors from "../../styles/colors.module.scss";
import { staticSelect } from "../utils/react";
import { FXWrapper } from '../fx/FXWrapper';

export class Synth extends BaseSynth {
    static metadata = {
        tipus: 'synth',
        tipusDisplay: 'Synth Legacy',
        versio: '0.1',
        color: colors.red,
        hasLogo: true,
        hasMiniature: true,
    }
    static parametersDescription = addKeysAsField({
        ...super.parametersDescription,
        fx_distortion_isActive: {type : 'bool', initial: true, bind: "preset"},
        fx_distortion_amount:{type: 'float', min: 0.0, max: 1.0, initial: 0.0, bind: "preset"},
        env_attack: {...super.parametersDescription.env_attack, initial: 1.2},
        env_decay: {...super.parametersDescription.env_decay, initial: 2.0},
        env_sustain: {...super.parametersDescription.env_sustain, initial: 0.8},
        env_release: {...super.parametersDescription.env_release, initial: 2.0},
        lpf_cutoff: {...super.parametersDescription.lpf_cutoff, initial: 1400}
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {min: 60, max: 83}
    }

    getUserInterfaceComponent() {
        return SynthUI
    }

    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph({poly: true})
    }

    addEffectChainNodes(audioInput, audioOutput) {
        this.distortionNode = new FXWrapper(Distortion, {postgain: 1, isActive: staticSelect(this.getPlaybackParameterSelector("fx_distortion_isActive"))});
        audioInput.chain(this.distortionNode, audioOutput);
        super.addEffectChainNodes(audioInput, audioOutput);
    }

    setParameterInAudioGraph(name, value) {
        if (name == "fx_distortion_amount"){
            this.distortionNode.set({'wet': 0.5});
            this.distortionNode.set({'distortion': value});
            const makeupGain = dbToGain(-1 * Math.pow(value, 0.25) * 6);  // He ajustat aquests valors manualment perquè el crossfade em sonés bé
            this.distortionNode.postgain.set({'gain': makeupGain});
        } else if (name == "fx_distortion_isActive") {
            if (value) this.distortionNode.activate();
            else this.distortionNode.deactivate();
        } else super.setParameterInAudioGraph(name, value);
        return true;
    }

    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.synth.releaseAll()
    }

    onStopAllSounds() {
        // Stop all notes, and set env_release time to 0
        this.setParameterInAudioGraph('env_release', 0.0);
        this.audioNodes.synth.releaseAll();
        this.setParameterInAudioGraph('env_release', staticSelect(this.getDisplayParameterSelector('env_release')));
    }

    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!getAudioGraphInstance().isGraphBuilt()) return;

        pitch = this.adjustPitchToInstrumentRange(pitch);
        let soundingPitch = this.adjustPitchForWaveform(pitch);
        soundingPitch += this.getPlaybackParameterValue("osc_octave") * 12;
        const frequency = Frequency(soundingPitch, "midi");
        if (!noteOff) this.audioNodes.synth.triggerAttack([frequency], undefined, midiVelocity/127);
        else this.audioNodes.synth.triggerRelease([frequency]);

        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}
